module.exports = __webpack_public_path__ + "static/media/button_appstore.e1e0b6aa.png";